// extracted by mini-css-extract-plugin
export var avatarContainer = "_76-0";
export var avatarTypingWave = "_76-i";
export var gray = "_76-f";
export var green = "_76-c";
export var icon = "_76-9";
export var image = "_76-1";
export var lg = "_76-6";
export var md = "_76-5";
export var presenceDot = "_76-b";
export var red = "_76-d";
export var sm = "_76-4";
export var status = "_76-a";
export var typingDot = "_76-h";
export var typingPill = "_76-g";
export var xl = "_76-7";
export var xs = "_76-3";
export var xxl = "_76-8";
export var xxs = "_76-2";
export var yellow = "_76-e";